export const DEFAULT_TICKETING_RATE = 0.05

export const DEFAULT_DONATIONS_RATE = 0.05

// Countries where Stripe does not allow US-based platforms to collect
// application fees via Direct Charges. For these countries, we set
// application_fee_amount to 0 and invoice the guild separately.
// Reference: https://docs.stripe.com/connect/direct-charges
const APPLICATION_FEE_RESTRICTED_COUNTRIES = new Set([
  'BR', // Brazil
])

export const canCollectApplicationFee = (
  countryCode: string | null | undefined
): boolean =>
  !!countryCode &&
  !APPLICATION_FEE_RESTRICTED_COUNTRIES.has(countryCode.toUpperCase())

// Countries whose guilds onboard to dLocal Go instead of Stripe. dLocal Go
// supports Pix, boleto and local cards with installments, and collects the
// platform fee through a split payment.
const DLOCAL_GO_COUNTRIES = new Set(['BR'])

// Off in production until Guild's dLocal Go production access is approved.
// While off, Brazilian guilds keep onboarding to Stripe.
export const DLOCAL_GO_ENABLED = process.env.GUILD_ENV !== 'production'

export const isDlocalGoCountry = (
  countryCode: string | null | undefined
): boolean =>
  DLOCAL_GO_ENABLED &&
  !!countryCode &&
  DLOCAL_GO_COUNTRIES.has(countryCode.toUpperCase())
